<template>
	<div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 19px;">
		<router-link :to="`/education/courses/${item}`" v-for="item in 9">
			<img src="/img/course-thumbnail.png" style="width: 100%;">
		</router-link>
	</div>
</template>